import React, { FC } from 'react';
import Icon from '~ComponentsImproved/Icon';
import { useButton, useI18n } from '~Hooks';
import { HeaderBox } from '~Scenes/Onboarding/styles';
import LayoutPos from './LayoutPos';
import Heading from '~ComponentsImproved/Typography/Heading';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import LayoutIcon from '~Assets/icons/edit_layout.svg';
import { TransparentButton } from '~Styles';

interface Props {
  isHandy?: boolean;
  onSkipClick: () => void;
}

const SelectLayout: FC<Props> = ({ isHandy, onSkipClick }) => {
  const { i18n } = useI18n();

  const skipButton = useButton({
    onClick: () => {
      onSkipClick();
    },
  });

  return (
    <>
      <HeaderBox
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="xs"
        justifyContent="center">
        <Icon
          height={isHandy ? '48px' : '64px'}
          width={isHandy ? '48px' : '64px'}
          src={LayoutIcon}
          color="var(--colorBlueGray200)"
        />
        <Heading level={isHandy ? 3 : 1} color="var(--colorWhite)">
          {i18n('Onboarding.LayoutConfig')}
        </Heading>
        <Paragraph level={isHandy ? 5 : 2} color="var(--colorBlueGray200)">
          {i18n('Onboarding.LayoutConfig.Text')}{' '}
        </Paragraph>
      </HeaderBox>

      <LayoutPos isOnboarding />

      <TransparentButton {...skipButton}>
        <Paragraph level={3} color="var(--colorBlueGray200)">
          {i18n('Onboarding.SkipContinue')}
        </Paragraph>
      </TransparentButton>
    </>
  );
};

export default SelectLayout;
